$(document).ready(function () {
  $(".navbar-toggler").click(function () {
    var $nav = $("#navbarSupportedContent");
    if (!$nav.hasClass("open")) {
      // Show the bottom sheet by sliding it up from off-screen
      $(this).removeClass("disableDrawer");
      $nav
        .css({
          display: "block",
          bottom: "-100%",
        })
        .animate({ bottom: "0" }, 300, function () {
          $nav.addClass("open");
        });
    } else {
      // Slide the bottom sheet back down off-screen, then hide it
      $(this).addClass("disableDrawer");
      $nav.animate({ bottom: "-100%" }, 300, function () {
        $nav.css("display", "none").removeClass("open");
      });
    }
  });
  if ($(".user-menu-drawer").length) {
    $(".menu-toggle").on("click", function () {
      $(".user-menu-drawer").slideToggle("slow");
    });
  }
  function cartItemHtml(item) {
    return `
      <div class="cart-item">
      <img src="${item.image}" alt="Product">
      <div class="item-details">
        <p class="item-title">${item.product_title}</p>
        <span class="item-category">Vacuum Cleaner</span>
        <p class="item-price">${
          "Rs. " + (item.price / 100).toLocaleString("en-IN")
        }</p>
      </div>
      <div class="item-controls">
        <div class="quantity-control">
          <input type="number" value="${
            item.quantity
          }" min="1" class="qty-input" data-sharkid="__0">
          <span>
            <button class="qty-btn plus" data-varient_id="${
              item.variant_id
            }"><i class="bi bi-chevron-up"></i></button>
            <button class="qty-btn minus" data-varient_id="${
              item.variant_id
            }"><i class="bi bi-chevron-down"></i></button>
          </span>
        </div>
        <button class="remove-btn" data-item_id="${item.id}">Remove</button>
      </div>
    </div>  
    `;
  }
  function updateCart(e) {
    e.preventDefault();
    var $form = $(this);
    var formData = $form.serialize();
    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: formData,
      dataType: "json",
      success: function (item) {
        console.log("Added to cart:", item);
        $(document).trigger("addedToCart");
        toggleCartSidebar();
      },
      error: function (xhr, status, error) {
        console.error("Error adding to cart:", error);
        alert("❌ Failed to add item to cart.");
      },
    });
  }
  function bindCartActions() {
    // Increase quantity
    $(".qty-btn.plus").on("click", function (e) {
      e.preventDefault();
      var variantId = $(this).data("varient_id");
      var $qtyInput = $(this).closest(".quantity-control").find(".qty-input");
      var currentQty = parseInt($qtyInput.val(), 10);
      var newQty = currentQty + 1;

      $.ajax({
        type: "POST",
        url: "/cart/change.js",
        data: { id: variantId, quantity: newQty },
        dataType: "json",
        success: function (data) {
          $qtyInput.val(newQty);
          console.log(
            "Quantity increased to:",
            newQty,
            "for variant:",
            variantId
          );
          $(document).trigger("addedToCart");
          // Optionally update other parts of your cart UI here
        },
        error: function (xhr, status, error) {
          console.log("Error increasing quantity:", error);
        },
      });
    });

    // Decrease quantity
    $(".qty-btn.minus").on("click", function (e) {
      e.preventDefault();
      var variantId = $(this).data("varient_id");
      var $qtyInput = $(this).closest(".quantity-control").find(".qty-input");
      var currentQty = parseInt($qtyInput.val(), 10);

      if (currentQty > 1) {
        var newQty = currentQty - 1;
        $.ajax({
          type: "POST",
          url: "/cart/change.js",
          data: { id: variantId, quantity: newQty },
          dataType: "json",
          success: function (data) {
            $qtyInput.val(newQty);
            console.log(
              "Quantity decreased to:",
              newQty,
              "for variant:",
              variantId
            );
            $(document).trigger("addedToCart");
            // Optionally update other parts of your cart UI here
          },
          error: function (xhr, status, error) {
            console.log("Error decreasing quantity:", error);
          },
        });
      }
    });

    // Remove item from cart
    $(".remove-btn").on("click", function (e) {
      e.preventDefault();
      // Using data-item_id if available, or fallback to data-varient_id
      var variantId = $(this).data("item_id") || $(this).data("varient_id");

      $.ajax({
        type: "POST",
        url: "/cart/change.js",
        data: { id: variantId, quantity: 0 },
        dataType: "json",
        success: function (data) {
          // Remove the cart item from the DOM
          $(e.target).closest(".cart-item").remove();
          console.log("Item removed with id:", variantId);
          $(document).trigger("addedToCart");
          // Optionally update the cart summary here
        },
        error: function (xhr, status, error) {
          console.log("Error removing item:", error);
        },
      });
    });
  }
  /* Add To Cart */
  $('form[action="/cart/add"]').on("submit", updateCart);
  $(document).on("addedToCart", (cart) => {
    $.getJSON("/cart.js", function (cart) {
      $(".cartt-items").html("");
      if (!cart.items.length) {
        $(".cartt-items").html(
          '<span class="empty-cart">Your cart is currently empty.</span>'
        );
        $(".cart-footer").addClass("opacity-0");
      }
      $(cart.items).each((index, item) => {
        let html = cartItemHtml(item);
        $(".cartt-items").append(html);
        $(".cart-footer").removeClass("opacity-0");
      });
      $(".subtotal span").html(
        "Rs. " + (cart.total_price / 100).toLocaleString("en-IN")
      );
      $(".cart-items").html(cart.item_count);
      bindCartActions();
    });
  });
  $(document).trigger("addedToCart");
});
